import React, {FC} from 'react';
import styled, {css} from 'styled-components';

/*
 * Props.
 */

interface AvatarImageProps {
  imageUrl: string;
  isFaded?: boolean;
  className?: string;
}

/*
 * Style.
 */

interface AvatarImageStyleProps {
  $isFaded?: boolean;
}
const StyledImageDiv = styled.div<AvatarImageStyleProps>`
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 50%;

  background-size: cover;
  background-position: center center;

  // Reduces some blurriness that occurs.
  image-rendering: -webkit-optimize-contrast;
  image-rendering: crisp-edges;

  box-shadow: inset 0 0 0 1px ${(p) => p.theme.alphas.black20};
  ${(p) => p.$isFaded && addFadedStyle};
`;

function addFadedStyle() {
  return css`
    filter: saturate(0);
    opacity: 0.6;
  `;
}

/*
 * Component.
 */

export const AvatarImage: FC<AvatarImageProps> = (props) => (
  <StyledImageDiv
    className={props.className}
    style={{backgroundImage: `url(${props.imageUrl})`}}
    $isFaded={props.isFaded}
  />
);
